import { _ } from "js/vendor";
import { themes as themesApi } from "apis-v2/callables";
import type { ITheme } from "common/interfaces";
import db from "js/db";

import ApiAdapter from "./apiAdapter";

class ThemesAdapter extends ApiAdapter<ITheme, {}> {
    async _createApi(model: ITheme) {
        return await themesApi.createTheme(model);
    }

    async _updateApi(
        changesetUpdates: Partial<ITheme>, changesetOriginal: Partial<ITheme>, replaceKeys: boolean = false
    ): Promise<Partial<ITheme>> {
        const { modifiedAt, _changeId } = await themesApi.updateTheme({
            id: this.id,
            changesetOriginal,
            changesetUpdates,
            _changeId: this.model.attributes._changeId,
            replaceKeys
        });
        return { modifiedAt, _changeId };
    }

    async _getApi() {
        return await themesApi.getTheme({
            id: this.id,
        });
    }

    _composeModel(baseModel: Partial<ITheme>): ITheme {
        return { ...baseModel, id: this.id } as ITheme;
    }

    _getPusherChannelId(): string | null {
        return `private-theme-${this.id}`;
    }

    createUid() {
        return db().push().key as string;
    }
}

export default ThemesAdapter;
